import jquery from 'jquery'
const $ = jquery

export default class Share {
    start() {
        if ($('.social-share').length > 0) {
            $('.social-share-link').click(function (e) {
              e.preventDefault()
              const url = $(this).data('url')
              window.open(url, '_blank', 'width=600,height=400')
            })
          }
    }
}
